<template>
  <b-card
    no-body
    tag="button"
    type="button"
    @click="handleAdd"
    class="w-100 h-100 justify-content-center align-items-center"
  >
    <b-icon icon="plus-square-fill" font-scale="6" variant="secondary" />
    <span class="sr-only">Add new item</span>
  </b-card>
</template>

<script>
export default {
  props: {
  },
  data() {
    return {
    };
  },
  methods: {
    handleAdd() {
      this.$emit('add');
    },
  },
};
</script>
